import App from '@/app/shared/App.vue';
import SharedLinkUnavailable from '@/app/shared/pages/SharedLinkUnavilable.vue';

const PAGE_LEVEL_TOP = `Shared Link`;

export default {
  path: '',
  component: App,
  meta: {
    hideNav: true,
    hidePrimaryNav: true,
    hideSecondaryNav: true,
    hideVisionAi: true,
  },
  children: [
    {
      name: 'shared.link-unavailable',
      path: 'shared-link-unavailable',
      component: SharedLinkUnavailable,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Unavailable`,
      },
    },
  ],
};
